<template>
  <div>
    <b-card class="sa-card sa-card-border" header="Anagrafica" header-tag="header" footer-tag="footer" title="">
      <b-row class="sa-padding-left text-left" style="margin-left: 0.5rem; margin-right: 0.5rem; margin-bottom: 0.5rem">
        <b-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
          <label class="sa-label-data">Codice Fiscale Assistito <span style="color: red">*</span></label>
          <div role="codicefiscaleinput">
            <b-form-input v-model="localData.identificativo"
              :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)" @input="emitChange()"
              :state="getStateValidationField('identificativo')" aria-describedby="input-live-feedback"
              placeholder="Inserisci codice fiscale assistito" trim></b-form-input>

            <b-form-invalid-feedback id="input-live-feedback">
              {{ getMsg("identificativo") }}
            </b-form-invalid-feedback>

            <!-- <b-form-text id="name-help">Esempio</b-form-text> -->
          </div>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
          <div role="cognomeinput">
            <label class="sa-label-data">Cognome <span style="color: red">*</span></label>
            <b-form-input :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)" v-model="localData.cognome"
              aria-describedby="input-live-feedback" placeholder="Inserisci cognome assistito"
              :state="getStateValidationField('cognome')" @input="emitChange()"></b-form-input>
            <b-form-invalid-feedback id="input-live-feedback">
              {{ getMsg("cognome") }}
            </b-form-invalid-feedback>
          </div>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
          <div role="cognomeinput">
            <label class="sa-label-data">Nome <span style="color: red">*</span></label>
            <b-form-input :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)" v-model="localData.nome"
              aria-describedby="input-live-feedback" :state="getStateValidationField('nome')"
              placeholder="Inserisci nome assistito" @input="emitChange()"></b-form-input>
            <b-form-invalid-feedback id="input-live-feedback">
              {{ getMsg("nome") }}
            </b-form-invalid-feedback>
          </div>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="" xl="2">
          <label class="sa-label-data">Data Nascita <span style="color: red">*</span></label>
          <date-picker format="DD/MM/YYYY" value-type="timestamp" placeholder="Inserisci Data Nascita"
            :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)" v-model="localData.dataNascita"
            @input="emitChange()" type="date"></date-picker>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
          <div role="sessoinput">
            <label class="sa-label-data">Sesso <span style="color: red">*</span></label>
            <b-form-select :state="getStateValidationField('sesso')" v-model="localData.sesso"
              class="mb-2 mr-sm-2 mb-sm-0" :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)"
              :options="sessoOption" :value="null" @change="emitChange()">
              <template #first>
                <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
              </template>
            </b-form-select>
            <b-form-invalid-feedback id="input-live-feedback">
              {{ getMsg("sesso") }}
            </b-form-invalid-feedback>
          </div>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
          <div role="provincianascitainput">
            <label class="sa-label-data">Provincia Nascita <span style="color: red">*</span></label>
            <b-form-select v-model="localData.provinciaNascita"
              :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)" class="mb-2 mr-sm-2 mb-sm-0"
              :options="provinciaNascitaOptions" :state="getStateValidationField('provinciaNascita')"
              value-field="sigla" text-field="provincia" @change="loadComune(localData.provinciaNascita)" :value="null">
              <template #first>
                <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
              </template>
            </b-form-select>
          </div>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="5" xl="5">
          <div role="comunenascitainput">
            <label class="sa-label-data">Comune Nascita <span style="color: red">*</span></label>
            <b-form-select v-model="localData.comuneNascitaCodiceIstat"
              :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)"
              :state="getStateValidationField('comuneNascitaCodiceIstat')" class="mb-2 mr-sm-2 mb-sm-0"
              :options="comuniNascitaOptions" :value="null" @change="emitChange()">
              <template #first>
                <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
              </template>
            </b-form-select>
            <b-form-invalid-feedback id="input-live-feedback">
              {{ getMsg("comuneNascitaCodiceIstat") }}
            </b-form-invalid-feedback>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <b-card class="sa-card sa-card-border" header="Contatti" header-tag="header" footer-tag="footer" title="">
      <b-row class="sa-padding-left text-left" style="margin-left: 0.5rem; margin-right: 0.5rem; margin-bottom: 0.5rem">
        <b-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
          <div role="telefonoinput">
            <label class="sa-label-data">Telefono <span style="color: red">*</span></label>
            <b-form-input :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)" v-model="localData.telefono"
              placeholder="Inserisci Telefono" :state="getStateValidationField('telefono')"
              @input="emitChange()"></b-form-input>
            <b-form-invalid-feedback id="input-live-feedback">
              {{ getMsg("telefono") }}
            </b-form-invalid-feedback>
          </div>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
          <div role="emailinput">
            <label class="sa-label-data">Email </label>
            <b-form-input :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)" v-model="localData.email"
              placeholder="Inserisci Email" :state="getStateValidationField('email')"
              @input="emitChange()"></b-form-input>
            <b-form-invalid-feedback id="input-live-feedback">
              {{ getMsg("email") }}
            </b-form-invalid-feedback>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <b-row>
      <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
        <b-card class="sa-card sa-card-border" header="Residenza" header-tag="header" footer-tag="footer" title="">
          <b-row>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
              <div role="regioneResidenzainput">
                <label class="sa-label-data">Regione <span style="color: red">*</span></label>
                <b-form-select class="mb-2 mr-sm-2 mb-sm-0" :value="null"
                  :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)" v-model="localData.regioneResidenza"
                  value-field="codiceIstat" :state="getStateValidationField('regioneResidenza')" text-field="regione"
                  :options="regioniResidenzaOptions" @change="onChangeRegioneResidenza" required>
                  <template #first>
                    <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
                  </template>
                </b-form-select>
                <b-form-invalid-feedback id="input-live-feedback">
                  {{ getMsg("regioneResidenza") }}
                </b-form-invalid-feedback>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
              <div role="provinciaResidenzainput">
                <label class="sa-label-data">Provincia <span style="color: red">*</span></label>
                <b-form-select class="mb-2 mr-sm-2 mb-sm-0" :value="null"
                  :state="getStateValidationField('provinciaResidenza')"
                  :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)"
                  v-model="localData.provinciaResidenza" value-field="sigla" text-field="provincia"
                  :options="provinceResidenzaOptions" @change="onChangeProvinciaResidenza" required>
                  <template #first>
                    <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
                  </template>
                </b-form-select>
                <b-form-invalid-feedback id="input-live-feedback">
                  {{ getMsg("provinciaResidenza") }}
                </b-form-invalid-feedback>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
              <div role="comuneResidenzaCodiceIstatinput">
                <label class="sa-label-data">Comune <span style="color: red">*</span></label>
                <b-form-select class="mb-2 mr-sm-2 mb-sm-0" :value="null"
                  :state="getStateValidationField('comuneResidenzaCodiceIstat')"
                  :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)"
                  v-model="localData.comuneResidenzaCodiceIstat" value-field="codiceIstat" text-field="comune"
                  :options="comuniResidenzaOptions" @change="onChangeComuneResidenza" required>
                  <template #first>
                    <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
                  </template>
                </b-form-select>
                <b-form-invalid-feedback id="input-live-feedback">
                  {{ getMsg("comuneResidenzaCodiceIstat") }}
                </b-form-invalid-feedback>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
              <div role="capResidenzainput">
                <label class="sa-label-data">CAP</label>
                <b-form-input v-model="localData.capResidenza" :state="getStateValidationField('capResidenza')"
                  :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)"
                  @input="emitChange()"></b-form-input>
                <b-form-invalid-feedback id="input-live-feedback">
                  {{ getMsg("capResidenza") }}
                </b-form-invalid-feedback>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
              <div role="indirizzoResidenzainput">
                <label class="sa-label-data">Indirizzo <span style="color: red">*</span></label>
                <b-form-input v-model="localData.indirizzoResidenza"
                  :state="getStateValidationField('indirizzoResidenza')"
                  :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)"
                  @input="emitChange()"></b-form-input>
                <b-form-invalid-feedback id="input-live-feedback">
                  {{ getMsg("indirizzoResidenza") }}
                </b-form-invalid-feedback>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>

      <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
        <b-card class="sa-card sa-card-border" header="Domicilio" header-tag="header" footer-tag="footer" title="">
          <template #header>
            <div style="display: flex">
              <span style="flex: 1">Domicilio</span>
              <b-form-checkbox v-model="isDomicilioUgualeResidenza" name="check-button" switch
                :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)">Coincide con
                residenza</b-form-checkbox>
            </div>
          </template>
          <b-row>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
              <div role="regioneDomicilioinput">
                <label class="sa-label-data">Regione <span style="color: red">*</span></label>
                <b-form-select class="mb-2 mr-sm-2 mb-sm-0" v-model="localData.regioneDomicilio"
                  :state="getStateValidationField('regioneDomicilio')" :value="null" value-field="codiceIstat"
                  text-field="regione" :options="regioniDomicilioOptions" @input="onInputRegioniDomicilio"
                  :disabled="isDomicilioUgualeResidenza || !isEdit || (isDematerializzata && isActionAnagrafica)">
                  <template #first>
                    <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
                  </template>
                </b-form-select>
                <b-form-invalid-feedback id="input-live-feedback">
                  {{ getMsg("regioneDomicilio") }}
                </b-form-invalid-feedback>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
              <div role="provinciaDomicilioinput">
                <label class="sa-label-data">Provincia <span style="color: red">*</span></label>
                <b-form-select v-model="localData.provinciaDomicilio" class="mb-2 mr-sm-2 mb-sm-0"
                  :options="provinceDomicilioOptions" :value="null"
                  :state="getStateValidationField('provinciaDomicilio')" value-field="sigla" text-field="provincia"
                  @input="onInputProvinciaDomicilio" required
                  :disabled="isDomicilioUgualeResidenza || !isEdit || (isDematerializzata && isActionAnagrafica)">
                  <template #first>
                    <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
                  </template>
                </b-form-select>
                <b-form-invalid-feedback id="input-live-feedback">
                  {{ getMsg("provinciaDomicilio") }}
                </b-form-invalid-feedback>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
              <div role="comuneDomicilioCodiceIstatinput">
                <label class="sa-label-data">Comune <span style="color: red">*</span></label>
                <b-form-select v-model="localData.comuneDomicilioCodiceIstat" class="mb-2 mr-sm-2 mb-sm-0"
                  :state="getStateValidationField('comuneDomicilioCodiceIstat')" :value="null" value-field="codiceIstat"
                  text-field="comune" :options="comuniDomicilioOptions" @input="onInputComuneDomicilio" required
                  :disabled="isDomicilioUgualeResidenza || !isEdit || (isDematerializzata && isActionAnagrafica)">
                  <template #first>
                    <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
                  </template>
                </b-form-select>
                <b-form-invalid-feedback id="input-live-feedback">
                  {{ getMsg("comuneDomicilioCodiceIstat") }}
                </b-form-invalid-feedback>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
              <div role="capDomicilioinput">
                <label class="sa-label-data">CAP</label>
                <b-form-input v-model="localData.capDomicilio"
                  :disabled="isDomicilioUgualeResidenza || !isEdit || (isDematerializzata && isActionAnagrafica)"
                  :state="getStateValidationField('capDomicilio')"></b-form-input>
                <b-form-invalid-feedback id="input-live-feedback">
                  {{ getMsg("capDomicilio") }}
                </b-form-invalid-feedback>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
              <div role="indirizzoDomicilioinput">
                <label class="sa-label-data">Indirizzo <span style="color: red">*</span></label>
                <b-form-input v-model="localData.indirizzoDomicilio"
                  :disabled="isDomicilioUgualeResidenza || !isEdit || (isDematerializzata && isActionAnagrafica)"
                  @input="emitChange()" :state="getStateValidationField('indirizzoDomicilio')"></b-form-input>
                <b-form-invalid-feedback id="input-live-feedback">
                  {{ getMsg("indirizzoDomicilio") }}
                </b-form-invalid-feedback>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
        <b-card class="sa-card sa-card-border" header="ASL di residenzaa" header-tag="header" footer-tag="footer"
          title="">
          <b-row>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
              <label class="sa-label-data">Codice A.S.L.</label>
              <b-form-input v-model="localData.aslResidenzaCodice"
                :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)" @input="emitChange()"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
              <label class="sa-label-data">A.S.L.</label>
              <b-form-input v-model="localData.aslResidenzaDenominazione"
                :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)" @input="emitChange()"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
              <label class="sa-label-data">Ambito</label>

              <b-form-select :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)" @change="emitChange()"
                v-model="localData.aslResidenzaAmbito" :options="ambitiAslResidenzaOptions" text-field="text"
                value-field="value"></b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
              <label class="sa-label-data">Distretto</label>
              <b-form-input v-model="localData.aslResidenzaDistretto"
                :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)" @input="emitChange()"></b-form-input>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
        <b-card class="sa-card sa-card-border" header="ASL di domicilio" header-tag="header" footer-tag="footer"
          title="">
          <b-row>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
              <label class="sa-label-data">Codice A.S.L.</label>
              <b-form-input v-model="localData.aslDomicilioCodice"
                :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)" @input="emitChange()"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
              <label class="sa-label-data">A.S.L.</label>
              <b-form-input v-model="localData.aslDomicilioDenominazione"
                :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)" @input="emitChange()"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
              <label class="sa-label-data">Ambito</label>
              <b-form-input v-model="localData.aslDomicilioAmbito"
                :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)" @input="emitChange()"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
              <label class="sa-label-data">Distretto</label>
              <b-form-input v-model="localData.aslDomicilioDistretto"
                :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)" @input="emitChange()"></b-form-input>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import UtilityMixin from "../../../utility/UtilityMixin";
import DatePicker from "vue2-datepicker";
export default {
  components: { DatePicker },
  props: {
    jsonData: {
      type: Object,
      required: true,
      default: () => {
        return {};
      },
    },
    isEdit: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    isActionAnagrafica: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    isDematerializzata: {
      type: Boolean,
      required: true,
      default: () => {
        return false;
      },
    },
  },
  mixins: [UtilityMixin],
  data() {
    return {
      linkRegioni: "/regioni",
      linkProvince: "/province",
      linkComune: "/comuni/provincia",
      linkComuneIstat: "/comuni/istat",
      linkAslResouce: "/asl/comune",
      localData: {
        id: null,
        primaryKey: null,
        idAccettazione: null,
        tipo: null,
        identificativo: null,
        cognome: null,
        nome: null,
        dataNascita: new Date().getTime(),
        sesso: null,
        provinciaNascita: null,
        comuneNascitaCodiceIstat: null,
        comuneNascita: null,
        distretto: null,
        quartiere: null,
        regione: null,
        regioneResidenza: null,
        provinciaResidenza: null,
        comuneResidenzaCodiceIstat: null,
        indirizzoResidenza: null,
        capResidenza: null,
        regioneDomicilio: null,
        provinciaDomicilio: null,
        comuneDomicilioCodiceIstat: null,
        indirizzoDomicilio: null,
        capDomicilio: null,
        aslResidenzaCodice: null,
        aslResidenzaDenominazione: null,
        aslResidenzaAmbito: "",
        aslResidenzaDistretto: null,
        aslDomicilioCodice: null,
        gruppoSanguigno: null,
        aslDomicilioDenominazione: null,
        aslDomicilioAmbito: "",
        aslDomicilioDistretto: null,
        createDate: null,
        createUser: null,
        proprietario: null,
      },

      rules: {
        identificativo: {
          msg: "Identificativo non valido",
          rule: (val) => val != null && val.length >= 3,
        },
        cognome: {
          msg: "Cognome non valido",
          rule: (val) => val != null && val != null && val.length >= 3,
        },
        nome: {
          msg: "Nome non valido",
          rule: (val) => val != null && val.length >= 3,
        },
        sesso: {
          msg: "Sesso non valido",
          rule: (val) => val != null,
        },
        provinciaNascita: {
          msg: "Provincia Nascita non valida",
          rule: (val) => val != null,
        },
        comuneNascitaCodiceIstat: {
          msg: "Comune Nascita non valido",
          rule: (val) => val != null,
        },
        telefono: {
          msg: "Telefono non valido",
          rule: (val) => val != null && val.length <= 11,
        },
        email: {
          msg: "Email non valido",
          rule: (val) => val != null,
        },
        regioneResidenza: {
          msg: "Regione Residenza non valida",
          rule: (val) => val != null,
        },
        provinciaResidenza: {
          msg: "Provincia Residenza non valida",
          rule: (val) => val != null,
        },
        comuneResidenzaCodiceIstat: {
          msg: "Comune Residenza non valido",
          rule: (val) => val != null,
        },
        capResidenza: {
          msg: "Cap Residenza non valido",
          rule: (val) => val != null,
        },
        indirizzoResidenza: {
          msg: "Indirizzo Residenza non valido",
          rule: (val) => val != null,
        },
        regioneDomicilio: {
          msg: "Regione Domicilio non valida",
          rule: (val) => val != null,
        },
        provinciaDomicilio: {
          msg: "Provincia Domicilio non valida",
          rule: (val) => val != null,
        },
        comuneDomicilioCodiceIstat: {
          msg: "Comune Domicilio non valido",
          rule: (val) => val != null,
        },
        capDomicilio: {
          msg: "Cap Domicilio non valido",
          rule: (val) => val != null,
        },
        indirizzoDomicilio: {
          msg: "Indirizzo Domicilio non valido",
          rule: (val) => val != null,
        },
      },
      linkGruppiSangue: "/pazientigruppisanguigno",
      pathResourceAmbiti: "/serviziambiticomuni",
      pathResourceDistretti: "/servizidistretticomuni",
      isDomicilioUgualeResidenza: false,
      nazionalitaOptions: [],
      aslOptions: [],
      quartiereOptions: [],
      regioniResidenzaOptions: [],
      regioniDomicilioOptions: [],
      provinciaOptions: [],
      provinciaNascitaOptions: [],
      provinceResidenzaOptions: [],
      provinceDomicilioOptions: [],
      distrettiOptions: [],
      isResidenzaUgualeDomicilio: false,
      comuniNascitaOptions: [],
      comuniResidenzaOptions: [],
      comuniDomicilioOptions: [],
      gruppoSanguignoOption: [],
      ambitiAslResidenzaOptions: [],
      sessoOption: [
        { text: "Maschio", value: "M" },
        { text: "Femmina", value: "F" },
        { text: "Altro", value: "A" },
      ],
    };
  },
  mounted() {
    let me = this;

    me.loadRegioni();
    me.loadProvinceNascita();
    me.loadGruppiSangue();
    me.setJsonData(me.jsonData);
  },
  watch: {
    isDomicilioUgualeResidenza() {
      let me = this;
      me.setDomicilio();
    },
    jsonData: function (params) {
      this.setJsonData(params);
    },
    "localData.provinciaNascita": function (params) {
      let me = this;
      me.loadComune(params);
    },
    "localData.regioneResidenza": function (params) {
      let me = this;
      me.loadProvince(params, "residenza");
    },
    "localData.provinciaResidenza": function (params) {
      let me = this;
      me.loadComuni(params, "residenza");
    },
    "localData.provinciaDomicilio": function (params) {
      let me = this;
      me.loadComuni(params, "domicilio");
    },
  },
  methods: {
    stampaJson() { },
    loadGruppiSangue() {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + me.linkGruppiSangue;
      me.gruppoSanguignoOption = [];
      axios.get(link).then((response) => {
        response.data.data.forEach((element) => {
          me.gruppoSanguignoOption.push({ value: element.descrizione, text: this.$i18n.t(element.descrizione) });
        });
        me.gruppoSanguignoOption.unshift({ value: null, text: "-Seleziona Valore-" });
      });
    },

    getStateValidationField(fieldName) {
      let me = this;
      const field = me.localData[fieldName];
      if (field === null) {
        return null;
      }
      const rules = me.rules[fieldName];
      if (!rules) {
        return true;
      }
      return rules.rule(field);
    },

    getMsg(fieldName) {
      let me = this;
      const fieldValue = me.localData[fieldName];
      const valid = me.getStateValidationField(fieldName);
      const rules = me.rules[fieldName];
      if ((fieldValue && !valid) || fieldValue == null) {
        if (rules) return rules.msg;
      }
      return null;
    },
    setJsonData(params) {
      if (params || params == {}) {
        console.log("accettazione be ", params.accettazione.accettazioneAnagrafica);
        this.localData = { ...params.accettazione.accettazioneAnagrafica };
        // this.localData.gruppoSanguigno = params.accettazione.accettazioneAnagrafica.gruppoSanguigno;
        this.localData.aslResidenzaCodice = params.accettazione.accettazioniAsl.aslResidenzaCodice;
        this.localData.aslResidenzaDenominazione = params.accettazione.accettazioniAsl.aslResidenzaDenominazione;
        this.localData.aslResidenzaAmbito = params.accettazione.accettazioniAsl.aslResidenzaAmbito;
        this.localData.aslResidenzaDistretto = params.accettazione.accettazioniAsl.aslResidenzaDistretto;
        this.localData.aslDomicilioCodice = params.accettazione.accettazioniAsl.aslDomicilioCodice;
        this.localData.aslDomicilioDenominazione = params.accettazione.accettazioniAsl.aslDomicilioDenominazione;
        this.localData.aslDomicilioAmbito = params.accettazione.accettazioniAsl.aslDomicilioAmbito;
        this.localData.aslDomicilioDistretto = params.accettazione.accettazioniAsl.aslDomicilioDistretto;
      }
    },
    emitChange() {
      let me = this;
      me.$emit("changeJsonData", { ...me.localData });
    },
    loadProvinceNascita() {
      let me = this;
      me.provinciaNascitaOptions = [];
      let link = process.env.VUE_APP_PATH_API + me.linkProvince;
      axios
        .get(link)
        .then((response) => {
          me.provinciaNascitaOptions = response.data.data;
        })
        .catch((error) => {
          console.log("Il servizio delle province ha datao errore: " + error.response.status);
        });
    },
    setDomicilio() {
      let me = this;
      if (me.isDomicilioUgualeResidenza) {
        me.localData.regioneDomicilio = me.localData.regioneResidenza;
        me.localData.provinciaDomicilio = me.localData.provinciaResidenza;
        me.localData.comuneDomicilioCodiceIstat = me.localData.comuneResidenzaCodiceIstat;
        me.localData.capDomicilio = me.localData.capResidenza;
        me.localData.indirizzoDomicilio = me.localData.indirizzoResidenza;
        me.emitChange();
      }
    },
    onChangeRegioneResidenza(regione) {
      let me = this;
      me.localData.provinciaResidenza = null;
      me.provinceResidenzaOptions = [];
      me.loadProvince(regione, "residenza");
      me.setDomicilio();
      me.emitChange();
    },
    onInputRegioniDomicilio(regione) {
      let me = this;
      me.provinceDomicilioOptions = [];
      me.loadProvince(regione, "domicilio");
      me.emitChange();
    },
    onChangeProvinciaResidenza(provincia) {
      let me = this;
      me.localData.comuneResidenzaCodiceIstat = null;
      me.comuniResidenzaOptions = [];
      me.loadComuni(provincia, "residenza");
      me.setDomicilio();
      me.emitChange();
    },
    onChangeComuneResidenza(value) {
      let me = this;
      me.loadCap(value, "residenza");
      me.loadAsl(value, "residenza");
      me.setDomicilio();
      me.emitChange();
    },
    onInputProvinciaDomicilio(provincia) {
      let me = this;
      me.comuniDomicilioOptions = [];
      me.loadComuni(provincia, "domicilio");
    },
    onInputComuneDomicilio(value) {
      let me = this;
      me.loadCap(value, "domicilio");
      me.loadAsl(value, "domicilio");
      me.emitChange();
    },
    onInputCapResidenza() {
      let me = this;
      me.setDomicilio();
      me.emitChange();
    },
    onInputIndirizzoResidenza() {
      let me = this;
      me.setDomicilio();
      me.emitChange();
    },
    loadProvince(regione, destination) {
      let me = this;
      if (destination) {
        me.filtro = { regione: regione };
      } else {
        me.filtro = null;
      }
      let link = process.env.VUE_APP_PATH_API + me.linkProvince;
      axios.get(link, { params: me.filtro }).then((response) => {
        response.data.data.forEach((provincia) => {
          switch (destination) {
            case "residenza":
              me.provinceResidenzaOptions.push(provincia);
              break;
            case "domicilio":
              me.provinceDomicilioOptions.push(provincia);
              break;
          }
        });
        if (me.id !== "-1") {
          me.setRegioni();
        }
      });
    },
    loadComuni(sigla, destination) {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + me.linkComune + "/" + sigla;
      axios
        .get(link)
        .then((response) => {
          response.data.data.forEach((comune) => {
            switch (destination) {
              case "nascita":
                me.comuniNascitaOptions.push(comune);
                break;
              case "residenza":
                me.comuniResidenzaOptions.push(comune);
                break;
              case "domicilio":
                me.comuniDomicilioOptions.push(comune);
                break;
            }
          });
        })
        .catch((error) => {
          console.log("Il servizio delle province ha datao errore: " + error.response.status);
        });
    },
    loadCap(codiceIstat, destination) {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + me.linkComuneIstat + "/" + codiceIstat;
      if (codiceIstat) {
        axios
          .get(link)
          .then((response) => {
            switch (destination) {
              case "residenza":
                me.localData.capResidenza = response.data.data.cap;

                break;
              case "domicilio":
                me.localData.capDomicilio = response.data.data.cap;
                break;
            }
          })
          .catch((error) => {
            console.log("Il servizio delle regioni ha datao errore: " + error.response.status);
          });
      }
    },
    loadRegioni() {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + me.linkRegioni;
      axios
        .get(link)
        .then((response) => {
          response.data.data.forEach((regione) => {
            me.regioniResidenzaOptions.push(regione);
            me.regioniDomicilioOptions.push(regione);
          });
        })
        .catch((error) => {
          console.log("Il servizio delle regioni ha datao errore: " + error.response.status);
        });
    },
    loadDistrettiAsl(codiceIstat, destination) {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + me.pathResourceDistretti;
      let params = { comuneCodiceIstat: codiceIstat };
      axios
        .get(link, { params: params })
        .then((response) => {
          //      response.data.data.list.forEach((element) => {
          switch (destination) {
            case "residenza":
              me.distrettiAslResidenzaOptions = [];
              //me.distrettiAslResidenzaOptions.push({ text: element.codiceAmbito, value: element.codiceAmbito });
              me.distrettiAslResidenzaOptions = response.data.data.list;
              if (response.data.data.list.length === 1) {
                me.jsonData.accettazioniAsl.aslResidenzaDistretto = response.data.data.list[0].codiceDistretto;
              }
              me.distrettiAslResidenzaOptions.unshift({ descrizione: "- Seleziona Valore -", codiceDistretto: null });
              break;
            case "domicilio":
              me.distrettiAslDomicilioOptions = [];
              me.distrettiAslDomicilioOptions = response.data.data.list; //.push({ text: element.codiceAmbito, value: element.codiceAmbito });
              if (response.data.data.list.length === 1) {
                me.jsonData.accettazioniAsl.aslDomicilioDistretto = response.data.data.list[0].codiceDistretto;
              }
              me.distrettiAslDomicilioOptions.unshift({ descrizione: "- Seleziona Valore -", codiceDistretto: null });
              break;
          }
          //  });
        })
        .catch((error) => {
          console.log("Il servizio delle province ha datao errore: " + error.response.data);
        });
    },
    loadAmbitiAsl(codiceIstat, destination) {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + me.pathResourceAmbiti;
      let params = { comuneCodiceIstat: codiceIstat };
      axios
        .get(link, { params: params })
        .then((response) => {
          response.data.data.list.forEach((element) => {
            switch (destination) {
              case "residenza":
                me.ambitiAslResidenzaOptions = [];
                me.ambitiAslResidenzaOptions.push({ text: element.codiceAmbito, value: element.codiceAmbito });
                console.log(response.data.data.list.length);
                if (response.data.data.list.length === 1) {
                  me.jsonData.accettazioniAsl.aslResidenzaAmbito = response.data.data.list[0].codiceAmbito;
                }
                break;
              case "domicilio":
                me.ambitiAslDomicilioOptions = [];
                me.ambitiAslDomicilioOptions.push({ text: element.codiceAmbito, value: element.codiceAmbito });
                if (response.data.data.list.length === 1) {
                  me.jsonData.accettazioniAsl.aslDomicilioAmbito = response.data.data.list[0].codiceAmbito;
                }
                break;
            }
          });
        })
        .catch((error) => {
          console.log("Il servizio delle province ha datao errore: " + error.response.data);
        });
    },
    loadComune(sigla) {
      let me = this;

      let link = process.env.VUE_APP_PATH_API + me.linkComune + "/" + sigla;
      axios.get(link).then((response) => {
        me.comuniNascitaOptions = [];
        response.data.data.forEach((element) => {
          me.comuniNascitaOptions.push({
            value: element.codiceIstat,
            text: element.comune,
          });
        });
      });
      me.emitChange();
    },
    loadAsl(codiceIstat, destination) {
      let me = this;

      let link = process.env.VUE_APP_PATH_API + me.linkAslResouce;
      let params = { istatComune: codiceIstat };
      if (codiceIstat) {
        axios
          .get(link, { params: params })
          .then((response) => {
            if (response.data.data !== null) {
              switch (destination) {
                case "residenza":
                  me.localData.aslResidenzaCodice = response.data.data.codiceRegione + response.data.data.codiceAzienda;
                  me.localData.aslResidenzaDenominazione = response.data.data.denominazione;

                  break;
                case "domicilio":
                  me.localData.aslDomicilioCodice = response.data.data.codiceRegione + response.data.data.codiceAzienda;
                  me.localData.aslDomicilioDenominazione = response.data.data.denominazione;
                  break;
              }
              me.emitChange();
            }
          })
          .catch((error) => {
            console.log(" errore: " + error.response.status);
          });
      }
    },
    setRegioni() {
      let me = this;
      me.provinceResidenzaOptions.forEach((element) => {
        if (element.sigla === me.localData.provinciaResidenza) {
          if (me.localData.regioneResidenza === null || me.localData.regioneResidenza === "") {
            me.localData.regioneResidenza = element.regione;
            me.emitChange();
          }
        }
        if (element.sigla === me.localData.provinciaDomicilio) {
          if (me.localData.regioneDomicilio === null || me.localData.regioneDomicilio === "") {
            me.localData.regioneDomicilio = element.regione;
            me.emitChange();
          }
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
